/**
 * CAPTION IT — Mobile nav drawer
 * Hamburger toggle, focus trap, close on link/escape, scroll lock.
 */
(function () {
  'use strict';

  function trapFocus(container, e) {
    const focusables = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function init() {
    const trigger = document.querySelector('[data-ci-nav-toggle]');
    const drawer = document.querySelector('[data-ci-drawer]');
    if (!trigger || !drawer) return;

    const closeBtn = drawer.querySelector('[data-ci-drawer-close]');
    const links = drawer.querySelectorAll('[data-ci-drawer-link]');

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ci-no-scroll');
      const firstLink = drawer.querySelector('[data-ci-drawer-close], [data-ci-drawer-link]');
      if (firstLink) firstLink.focus();
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ci-no-scroll');
      trigger.focus();
    }

    function toggle() {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) close();
      else open();
    }

    trigger.addEventListener('click', toggle);
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* Close drawer when a nav link is tapped (then let native scroll happen) */
    links.forEach(link => {
      link.addEventListener('click', () => {
        /* delay so the hash anchor scrolls after the drawer closes */
        setTimeout(close, 50);
      });
    });

    /* Escape key + focus trap while open */
    document.addEventListener('keydown', e => {
      if (drawer.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') trapFocus(drawer, e);
    });

    /* Auto-close if viewport upsizes (avoid lingering open state) */
    const mq = window.matchMedia('(min-width: 1025px)');
    mq.addEventListener('change', e => { if (e.matches) close(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
